import { flow, pipe } from 'fp-ts/function';
import { filter, get, groupBy, isNil, map, mapValues, negate, sumBy } from 'lodash/fp';

import { getOrZero } from '@mews/fp';

import { getCategorySpaceTypeEnumName } from '../../../modules/resourceCategories/selectors';
import { ApplicationState } from '../../../types';
import { WithEnterpriseId } from '../../../types/selectors/selectorPropTypes';
import { getCurrentDateEnterpriseAvailableCategories } from '../../availability';

export const getCurrentDateAvailableCategoriesSpaceTypeCounts = (
    state: ApplicationState,
    { enterpriseId }: WithEnterpriseId
) => {
    const categories = getCurrentDateEnterpriseAvailableCategories(state, { enterpriseId });

    return pipe(
        categories,
        map((category) => ({
            spaceTypeName: getCategorySpaceTypeEnumName(state, { categoryId: category.id }),
            availableCount: getOrZero('availableCount', category),
        })),
        filter(flow(get('spaceTypeName'), negate(isNil))),
        groupBy('spaceTypeName'),
        mapValues(sumBy('availableCount'))
    );
};
